import * as React from 'react'
import { useParams } from 'react-router-dom';
import { TabsProceso } from './Tabs/Tabs';
import './Proceso.css';



function Proceso(props) {

    const {id} = useParams();

    return (
        <React.Fragment>
            <div className="titleProceso">
                <div>{props.openCaseInfo.radicado}</div>
            </div>
            <TabsProceso
                idProceso={id}
                url={props.url}
            />
        </React.Fragment>
    );
}

export { Proceso };
